/**
 * Which world's mobs are being simulated right now.
 *
 * A dedicated server runs one EntityManager per dimension in one process, but
 * several mob registries are module-level sets (angry piglins, wild wolves,
 * villager block claims). `EntityManager.bind()` sets `realm.id` before a
 * manager does anything; each mob remembers the realm it was made in, and the
 * registries skip members of another realm. Offline there is one manager, so
 * every mob shares one realm and nothing changes.
 */
export const realm = { id: 0 };
